import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { FeatureFlag } from "@/types/feature-flag";

export const FEATURE_FLAGS_GET = "feature-flags-get";
export const PUBLIC_FEATURE_FLAGS_GET = "public-feature-flags-get";
export const FEATURE_FLAG_GET = "feature-flag-get";

// Flags are now served by the internal feature-flag service via dedicated
// Next.js routes (firm is resolved server-side). These routes are fail-safe and
// always respond 200 with a Record<string, FeatureFlag>; on any non-OK response
// we fall back to an empty record so flags resolve to their defaults.
export const getFeatureFlags = async (): Promise<
  Record<string, FeatureFlag>
> => {
  const response = await fetch("/api/feature-flags", {
    headers: { accept: "application/json" },
    cache: "no-store",
  });
  if (!response.ok) return {};
  return (await response.json()) as Record<string, FeatureFlag>;
};

export const getPublicFlags = async (): Promise<
  Record<string, FeatureFlag>
> => {
  const response = await fetch("/api/feature-flags/public", {
    headers: { accept: "application/json" },
    cache: "no-store",
  });
  if (!response.ok) return {};
  return (await response.json()) as Record<string, FeatureFlag>;
};

export const getFeatureFlagByName = async (featurename: string) => {
  try {
    const response = await http.get<FeatureFlag>(
      links.featureFlags.featureFlagByName(featurename),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
